import React, { useEffect } from "react"
import Editor from "react-simple-code-editor"
import styled from "styled-components"
import uuid from "uuid"

// @ts-ignore
import { highlight, languages } from "prismjs/components/prism-core"
import "prismjs/components/prism-http"
import "prismjs/components/prism-json"
import "prismjs/themes/prism-tomorrow.css"

import { SocketAPI, SocketEditorState } from "../../reducer/common.types"
import { SbDispatch } from "../../reducer/reducer"
import { monospaceCss } from "../../styles"

const SUREBDITS_UUID_SUFFIX = "5ec853f1a546"

interface Props<S extends SocketEditorState<SocketAPI>> {
  state: S
  setState: (newState: S) => any
  dispatch: SbDispatch
}

const getSuredbitsUUID = (): string => {
  const randomUuid = uuid()
  const suffixLength = 12
  return randomUuid.slice(0, -suffixLength) + SUREBDITS_UUID_SUFFIX
}

function getEditorValue(state: SocketEditorState<SocketAPI>): string {
  const newState = { ...state, uuid: cachedUUID }
  delete newState.api
  return JSON.stringify(newState, null, 2)
}

let cachedUUID: string = getSuredbitsUUID()

/**
 * Editor that lets the user construct websocket
 * messages
 */
export const WsMessageEditor: React.SFC<
  Props<SocketEditorState<SocketAPI>>
> = ({ state, dispatch }) => {
  // we want to update the UUID if the selected API changes
  useEffect(() => {
    cachedUUID = getSuredbitsUUID()
  }, [state.api])

  const editorValue = getEditorValue(state)

  useEffect(() => {
    dispatch({ type: "SET_CURRENT_MESSAGE_TO_BE_SENT", message: editorValue })
  }, [state])

  return (
    <StyledEditor
      placeholder="Once you're connected to an API you can construct your request here"
      highlight={code => highlight(code, languages.json)}
      padding="1em"
      disabled={true}
      onValueChange={() => {
        return // pass
      }}
      value={editorValue}
    />
  )
}

const StyledEditor = styled(Editor)`
  border: none;
  min-height: 30vh;
  flex: 1;
  background: rgb(45, 45, 45) !important;
  overflow-y: scroll !important;
  ${monospaceCss}
`
